import { render, staticRenderFns } from "./FormObservacion.vue?vue&type=template&id=c3c8cf36&"
import script from "./FormObservacion.vue?vue&type=script&lang=js&"
export * from "./FormObservacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports